<template>
  <router-view></router-view>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400&display=swap');

#app {
  font-family: 'Noto Sans TC', sans-serif, '微軟正黑體', 'Microsoft JhengHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background-color: #edf0f3;
  border-radius: 3px;
  // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: rgb(190, 186, 186);
  // outline: 1px solid slategrey;
}

.ql-editor {
  min-height: 300px;
}

.el-aside {
  padding-top: 20px;
  height: 100vh;
  z-index: 500;
  overflow-y: scroll;
  position: fixed;
  .el-menu {
    border: 0;
    .menu-main-title {
      cursor: default;
      text-align: center;
      .box {
        display: inline-block;
        text-align: left;
        margin: 0 auto;
        color: #002f7a;
        .chineseName {
          font-weight: bold;
          font-size: 20px;
          line-height: 28px;
        }
        .englishName {
          font-weight: bold;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100px !important;
  padding-top: 25px;
  position: fixed;
  left: 300px;
  right: 0;
  z-index: 500;
  background-color: white;
  .logoutBtn {
    height: 50px;
  }
  .bottom-line {
    border-bottom: 1px solid #e0e5ec;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: calc(100% - 40px);
    margin: 0 auto;
  }
  .pageName {
    font-size: 2rem;
    text-align: left;
  }
}
.main-content {
  position: relative;
  top: 100px;
  left: 300px;
  right: 0;
  width: calc(100vw - 300px - 8px);

  .formSubmitBtnBox {
    text-align: right;
    margin-right: 1rem;
  }

  .topicBoxUnderline {
    margin: 1rem 0;
    border-bottom: 1px solid #e0e5ec;
  }
}

.el-dialog {
  max-height: 70vh;
  overflow: auto;
}

/* 編輯分類鈕的CSS */
.el-button--noBorder {
  color: #1c5efd;
  border: none;
}
.el-button--noBorder:hover {
  color: #1c5efd;
  background-color: rgba(255, 255, 255, 0);
}
.el-button--noBorder:focus {
  color: #1a51d1;
  background-color: rgba(255, 255, 255, 0);
}

.el-image-viewer__close {
  background: #ffffff;
  color: #000000;
}
</style>

<script>
export default {
  metaInfo() {
    return {
      title: '金豐集團形象網站管理系統',
    };
  },
};
</script>
